import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CurrentSurveyModel, CurrentSurvey } from './models';
import { ResetSessionState } from 'app/states/session/session.actions';
import { StoreCurrentSurvey } from './survey.actions';

const defaults = (): CurrentSurveyModel => ({ currentSurvey: new CurrentSurvey() });

@State<CurrentSurveyModel>({
  name: 'currentSurvey',
  defaults: defaults()
})
export class CurrentSurveyState {

  @Selector()
  static currentSurvey(state: CurrentSurveyModel) {
    return state.currentSurvey;
  }

  constructor() {}

  @Action(StoreCurrentSurvey)
  storePublicConfig(context: StateContext<CurrentSurveyModel>, action: StoreCurrentSurvey) {
    context.patchState({
      currentSurvey: action.currentSurvey
    })
    
  }

  @Action(ResetSessionState)
  resetSessionState(context: StateContext<CurrentSurveyModel>) {
    context.setState(defaults());
  }

}
